import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import logger from 'redux-logger';
import { enableMapSet } from 'immer';

import rootReducer from '../redux/reducers';
import { rtkApi, rtkNoAuthApi } from '../redux/rtk';
import { rtkEngineApi } from '../redux/rtk/engine';

enableMapSet();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const m = getDefaultMiddleware({
      // TODO:
      /**
       * Temporarily set to false to avoid non-serializable error on console
       * need to refactor and resolve issues on redux actions payload that contains callback functions
       *
       * Ticket ref: https://larki.atlassian.net/browse/LP-2686
       */
      serializableCheck: false,
      immutableCheck: false,
    }).concat(rtkApi.middleware, rtkNoAuthApi.middleware, rtkEngineApi.middleware);
    if (process.env.ENABLE_REDUX_LOG) {
      // @ts-expect-error
      m.push(logger);
    }
    return m;
  },
  devTools: !!process.env.ENABLE_REDUX_DEVTOOLS,
});

// Enables refetchOnFocus/refetchOnReconnect for queries that opt in.
setupListeners(store.dispatch);

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
